import { Injectable } from "@angular/core";
import { IAddEditUser } from "src/app/Models/Interface/User/add-edit-user";
import { DataService } from "../DataService/data.service";
import { Observable } from "rxjs";
import { APIName } from "../../Models/APIEndPoints/APIName";
import { IPagination } from "src/app/Models/Interface/Pagination/pagination";
import { HttpParams } from "@angular/common/http";
import { IBaseDataList } from "src/app/Models/Interface/Base/base-data-list";
import { IMemberUser } from "src/app/Models/Interface/User/member-user";
import { IMemberState } from "src/app/Models/Interface/User/member-state";
import { IUser } from "src/app/Models/Interface/User/user";

@Injectable({
  providedIn: "root",
})
export class UserService {
  userOBJ = {} as any;
  pagination = {
    skip: 0,
    take: 15,
    pagesCount: 0,
    inPageNumber: 1,
    leftItems: 0,
  } as IPagination;
  search: string = "";
  filter: string = "";
  activate = {} as IMemberState;

  constructor(private dataService: DataService) {}

  addUser(): Observable<any> {
    // let formData = new FormData();
    // formData.append('FullName', this.userOBJ.FullName);
    // formData.append('EmailAddress', this.userOBJ.EmailAddress);
    // formData.append('AccountId', String(this.userOBJ.AccountId));
    // formData.append('RoleId', String(this.userOBJ.RoleId));
    // if (this.userOBJ.UserRolePermissions)
    //     formData.append('UserRolePermissions', String(this.userOBJ.UserRolePermissions));
    // if (this.userOBJ.Vessels)
    //     formData.append('Vessels', String(this.userOBJ.Vessels));
    return this.dataService.post(APIName.user.create, this.userOBJ);
  }

  editUser(): Observable<any> {
    // let formData = new FormData();
    // formData.append('UserId', String(this.userOBJ.UserId));
    // formData.append('FullName', this.userOBJ.FullName);
    // formData.append('EmailAddress', this.userOBJ.EmailAddress);
    // formData.append('AccountId', String(this.userOBJ.AccountId));
    // formData.append('RoleId', String(this.userOBJ.RoleId));
    // if (this.userOBJ.UserRolePermissions)
    //     formData.append('UserRolePermissions', String(this.userOBJ.UserRolePermissions));
    // if (this.userOBJ.Vessels)
    //     formData.append('Vessels', String(this.userOBJ.Vessels));
    return this.dataService.post(APIName.user.update, this.userOBJ);
  }

  getUserByRole(role: string): Observable<IBaseDataList<IMemberUser[]>> {
    let params = new HttpParams();
    // @ts-ignore
    params = params.append("roleCode", role);
    params = params.append("skip", this.pagination.skip);
    params = params.append("take", this.pagination.take);
    return this.dataService.getWithParams(APIName.user.getByRole, params);
  }

  changeUserActivate(): Observable<any> {
    return this.dataService.post(APIName.user.activate, this.activate);
  }

  verifyUser(token: string, email: string): Observable<any> {
    let params = new HttpParams();
    // @ts-ignore
    params = params.append("verificationToken", token);
    params = params.append("email", email);

    return this.dataService.getWithParams(APIName.user.verifyUser, params);
  }

  getUser(userId: number | null): Observable<IUser> {
    let params = new HttpParams();
    // @ts-ignore
    params = params.append("userId", userId);
    return this.dataService.getWithParams(APIName.user.userDetails, params);
  }
}
